"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Files = _interopRequireDefault(require("./Files"));

var _default = _Files.default;
exports.default = _default;
//# sourceMappingURL=index.js.map